import countries from 'i18n-iso-countries';

countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

export function getISOCountryName(countryCode) {
  return countries.getName(countryCode, 'en');
}
